exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-package[data-v-814b5402] {\n  background-image: none !important;\n  padding: 15px 0;\n}\n.service-package .service-details[data-v-814b5402] {\n  margin-bottom: 40px !important;\n}\n.service-package h3.text-bold[data-v-814b5402] {\n  font-size: 26px !important;\n}", ""]);

// exports
